import { v4 as uuidv4 } from 'uuid';

const CSRF_TOKEN_KEY = 'csrf-token';

/**
 * Manages CSRF (Cross-Site Request Forgery) protection tokens.
 */
export class CSRFProtection {
  /**
   * Generates a new, cryptographically strong CSRF token and stores it in sessionStorage.
   * @returns The newly generated token.
   */
  static generateToken(): string {
    const token = uuidv4().replace(/-/g, '') + uuidv4().replace(/-/g, '');
    sessionStorage.setItem(CSRF_TOKEN_KEY, token);
    return token;
  }

  /**
   * Retrieves the current CSRF token from sessionStorage.
   * @returns The stored token, or null if no token exists.
   */
  static getToken(): string | null {
    return sessionStorage.getItem(CSRF_TOKEN_KEY);
  }

  /**
   * Validates a given token against the one stored in sessionStorage.
   * @param token The token to validate.
   * @returns True if the token is valid, false otherwise.
   */
  static validateToken(token: string): boolean {
    const storedToken = this.getToken();
    return storedToken !== null && storedToken === token;
  }

  /**
   * Clears the CSRF token from sessionStorage.
   */
  static clearToken(): void {
    sessionStorage.removeItem(CSRF_TOKEN_KEY);
  }
}
